import { Pipe, PipeTransform } from '@angular/core';
import isEmpty from 'lodash.isempty';

@Pipe({name: 'filterCounter'})
export class FilterCounterPipe implements PipeTransform {
  transform(counter: number, filters: any[], itemValue: string | number, extended?: boolean): string | number {
    if (extended) {
      return `+${counter}`;
    }

    if (isEmpty(filters) || !itemValue) {
      return counter;
    }

    const isSelected = filters.some(f => f === itemValue);

    return isSelected ? counter : `+${counter}`;
  }
}
